import { render, staticRenderFns } from "./AddMid.vue?vue&type=template&id=51542044&"
import script from "./AddMid.vue?vue&type=script&lang=js&"
export * from "./AddMid.vue?vue&type=script&lang=js&"
import style0 from "./AddMid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports